var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRigthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.582262 0.594577C0.423241 0.760464 0.333984 0.984865 0.333984 1.21877C0.333984 1.45268 0.423241 1.67708 0.582262 1.84296L3.60471 5.02148L0.582263 8.15573C0.423242 8.32162 0.333984 8.54602 0.333984 8.77993C0.333984 9.01383 0.423242 9.23823 0.582263 9.40412C0.661634 9.48711 0.756065 9.55297 0.860109 9.59792C0.964152 9.64287 1.07575 9.66602 1.18846 9.66602C1.30117 9.66602 1.41277 9.64287 1.51681 9.59792C1.62085 9.55297 1.71529 9.48711 1.79466 9.40412L5.41477 5.6501C5.49479 5.5678 5.55831 5.46987 5.60165 5.36198C5.645 5.25409 5.66732 5.13836 5.66732 5.02148C5.66732 4.9046 5.645 4.78888 5.60165 4.68099C5.55831 4.57309 5.49479 4.47517 5.41477 4.39286L1.79466 0.594577C1.71529 0.511591 1.62085 0.445724 1.51681 0.400774C1.41277 0.355824 1.30117 0.332682 1.18846 0.332682C1.07575 0.332682 0.964152 0.355824 0.860108 0.400774C0.756065 0.445724 0.661634 0.511591 0.582262 0.594577Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRigthIcon);
export default __webpack_public_path__ + "static/media/arrow-rigth-icon.e9ac01150a0665562e96f6c18e3590c3.svg";
export { ForwardRef as ReactComponent };